import React, { PureComponent, Fragment } from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Button,
  Grid,
  Tabs,
  Tab,
  Typography,
  Tooltip,
} from '@material-ui/core'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import InputLabel from '@material-ui/core/InputLabel'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'

import { permissionsGroupOrder, permissionsGroupOrderMap, PermissionsList } from '../../utils/constants'
import { hasAccess, canEditRole } from '../../utils/api'
import EditActionComponent from '../../components/common/EditActionComponent'
import { EditableSwitch } from '../common/EditableComponents'
import { isFeatureFlagEnable } from '../../api/unleash'
import { UnleashToggles } from '../../types/unleashToggles'

const useStyles = (theme) => ({
  customWidth: {
    maxWidth: 250,
  },
})

class RolePermissions extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      selectedRole: {},
      updatedPermissions: [],
      activeTab: 'iPad',
      editMode: false,
      showInsightsV2Permissions: props.canUseInsightsV2Permissions || false,
      showBroadcastPermissions: props.canUseGlobalBroadcasts || false,
    }
  }

  setPassword = (event) => {
    this.setState({
      password: event.target.value,
    })
  }

  changeActiveTab = (event, eventKey) => {
    this.setState({
      activeTab: eventKey,
    })
  }

  handleChange(event) {
    const { roles, permissions = [] } = this.props

    const selectedRole =
      (roles &&
        roles.length &&
        roles.find((element) => {
          return element.id === event.target.value
        })) ||
      {}

    this.setState({
      selectedRole: {
        ...selectedRole,
      },
      updatedPermissions: [...permissions],
    })
  }

  enableAllPermissions = () => {
    const { selectedRole, activeTab } = this.state
    const { index, permissions = [] } = this.props

    let fileteredPermissions =
      permissions &&
      permissions.length &&
      permissions
        .filter((perm) => {
          return perm.section === activeTab && perm.group !== 'Insights'
        })
        .map((perm) => perm.key)

    //const allPermissions = permissions && permissions.length && permissions.map(perm => perm.key);

    fileteredPermissions = Array.from(
      new Set([...selectedRole.permissions, ...fileteredPermissions]),
    )

    this.props
      .onSave({ ...selectedRole, permissions: fileteredPermissions }, index)
      .then((res) => {
        const updatedRole = res[index].roles.find((role) => role.id === selectedRole.id)
        this.setState({
          selectedRole: updatedRole,
        })
      })
      .catch((err) => {})
  }

  disableAllPermissions = () => {
    const { selectedRole, activeTab } = this.state
    const { index, permissions } = this.props

    let fileteredPermissions =
      (permissions &&
        permissions.length &&
        permissions.filter((perm) => {
          return perm.section === activeTab
        })) ||
      []

    fileteredPermissions = fileteredPermissions.map((perm) => perm.key)

    fileteredPermissions = selectedRole.permissions.filter(
      (val) => !fileteredPermissions.includes(val),
    )

    this.props
      .onSave({ ...selectedRole, permissions: fileteredPermissions }, index)
      .then((res) => {
        const updatedRole = res[index].roles.find((role) => role.id === selectedRole.id)
        this.setState({
          selectedRole: updatedRole,
        })
      })
      .catch((err) => {})
  }

  onSave = () => {
    const { selectedRole } = this.state
    const { index } = this.props
    this.disableEdit()

    this.props
      .onSave(selectedRole, index)
      .then((res) => {
        const updatedRole = res[index].roles.find((role) => role.id === selectedRole.id)
        this.setState({
          selectedRole: updatedRole,
        })
      })
      .catch((err) => {})
  }

  onCancel = (role) => {
    const { roles } = this.props
    const selectedRole =
      (roles &&
        roles.length &&
        roles.find((element) => {
          return element.id === role.id
        })) ||
      {}
    this.setState({
      selectedRole,
    })
    this.disableEdit()
    //
  }

  enableEdit = () => {
    this.setState({
      editMode: true,
    })
  }

  disableEdit() {
    this.setState({
      editMode: false,
    })
  }

  updatePermissionStatus = (role, status, key, filteredPermissions, groupOrder, permission) => {
    const { permissions = [] } = role
    let updatedPermissions = [...permissions]
    
    const isBroadcastGroup = groupOrder === 'Broadcast';
    const isWebEditBroadcastPermissionToggled = key === PermissionsList.Broadcast.WEB_EDIT_BROADCAST;
    const isWebEditBroadcastPermissionEnabled = updatedPermissions.includes(PermissionsList.Broadcast.WEB_EDIT_BROADCAST);

    if (
      groupOrder === 'Insights' &&
      permission !== 'Dashboard view in web' &&
      permission !== 'Reports view in web'
    ) {
      this.updatePermissionStatusInsight(
        role,
        status,
        key,
        filteredPermissions,
        updatedPermissions
      )
    } 
    else if (
      isBroadcastGroup && 
      ((isWebEditBroadcastPermissionToggled && !isWebEditBroadcastPermissionEnabled) || 
      (!isWebEditBroadcastPermissionToggled && isWebEditBroadcastPermissionEnabled))
    ) {
      updatedPermissions = this.updatePermissionStatusBroadcast(status, updatedPermissions, filteredPermissions.map((row) => row.key))
    } 
    else {
      this.updatePermissionStatusDefault(status, key, updatedPermissions)
    }

    this.setState({
      selectedRole: {
        ...this.state.selectedRole,
        permissions: [...updatedPermissions],
      },
    })
  }

  updatePermissionStatusDefault = (status, key, updatedPermissions) => {
    if (status) {
      const index = updatedPermissions.findIndex((permission) => permission === key)
      if (index !== -1) updatedPermissions.splice(index, 1)
    } else {
      updatedPermissions.push(key)
    }
    this.setState({
      selectedRole: {
        ...this.state.selectedRole,
        permissions: [...updatedPermissions],
      },
    })
  }

  updatePermissionStatusInsight = (role, status, key, filteredPermissions, updatedPermissions) => {
    if (status) {
      const index = updatedPermissions.findIndex((permission) => permission === key)
      if (index !== -1) updatedPermissions.splice(index, 1)
    } else {
      filteredPermissions.map((row, i) => {
        const index = updatedPermissions.findIndex((permission) => permission === row.key)
        if (index !== -1) updatedPermissions.splice(index, 1)
      })
      updatedPermissions.push(key)
    }
  }

  updatePermissionStatusBroadcast = (status, updatedPermissions, filteredKeys) => {
    if (status) {
      updatedPermissions = updatedPermissions.filter((permission) => !filteredKeys.includes(permission))
    } else {
      updatedPermissions = updatedPermissions.filter((permission) => !filteredKeys.includes(permission))
      updatedPermissions.push(...filteredKeys)
    }
    return updatedPermissions
  }

  validateRole = (selectedRole) => {
    let isValidRole = false

    if (selectedRole) {
      isValidRole = canEditRole(selectedRole)
    }

    return isValidRole
  }

  render() {
    let { selectedRole = {}, updatedPermissions = [], activeTab, editMode } = this.state
    const { roles, classes } = this.props
    const editRole = this.validateRole(selectedRole)
    const isAdmin = selectedRole.name === 'Admin' ? true : false
    const permissionsToRender =
      updatedPermissions &&
      updatedPermissions.length &&
      updatedPermissions.filter((permission) => {
        return permission.section === activeTab
      })
      const { companyFeatures = {} } = this.props.companyReducer || {}
    let permissionsGroupOrderFiltered = this.state.showInsightsV2Permissions 
      ? Array.from(permissionsGroupOrder)
      : permissionsGroupOrder.filter(permissionGroupOrder => permissionGroupOrder !=='InsightsV2')
    
    permissionsGroupOrderFiltered = this.state.showBroadcastPermissions 
      ? Array.from(permissionsGroupOrderFiltered)
      : permissionsGroupOrderFiltered.filter(permissionGroupOrder => permissionGroupOrder !=='Broadcast')


    return (
      <Grid container>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Tabs
            value={activeTab}
            indicatorColor="primary"
            textColor="primary"
            onChange={this.changeActiveTab}
            centered
          >
            <Tab label="APP" value="iPad" />
            <Tab label="WEB" value="Web" />
          </Tabs>
          <Grid container className="margin-top-medium">
            <Grid item xs={12} sm={4} md={4} lg={3}>
              <Tooltip
                placement="right-start"
                title={
                  <Typography variant="div" className={'margin'}>
                    <Typography
                      variant="span"
                      className={'margin-top-small'}
                      style={{ fontSize: '14px' }}
                    >
                      There are hardcoded permissions for adding and editing roles
                    </Typography>
                    <ul>
                      <li>
                        <Typography
                          variant="span"
                          className={'margin'}
                          style={{ fontSize: '14px' }}
                        >
                          Admin roles can add and edit all roles
                        </Typography>
                      </li>
                      <li>
                        <Typography
                          variant="span"
                          className={'margin'}
                          style={{ fontSize: '14px' }}
                        >
                          Manager roles can add and edit below roles
                        </Typography>
                      </li>
                      <li>
                        <Typography
                          variant="span"
                          className={'margin'}
                          style={{ fontSize: '14px' }}
                        >
                          Shop Manager, Dispatcher, and Shop Dispatcher roles can add and edit below
                          roles
                        </Typography>
                      </li>
                      <li>
                        <Typography
                          variant="span"
                          className={'margin'}
                          style={{ fontSize: '14px' }}
                        >
                          Budtender, Driver, Front Desk, Custom, and Inactive roles cannot add or
                          edit any roles
                        </Typography>
                      </li>
                    </ul>
                  </Typography>
                }
                classes={{ tooltip: classes.customWidth }}
              >
                <InputLabel>Select Role</InputLabel>
              </Tooltip>
            </Grid>
            <Grid item xs={12} sm={4} md={4} lg={3} className="select-margin">
              <Select
                value={(selectedRole && selectedRole.id) || ''}
                displayEmpty={true}
                onChange={(event) => this.handleChange(event)}
                fullWidth={true}
              >
                <MenuItem value="">Select Role</MenuItem>
                {roles &&
                  roles.length &&
                  roles.map((role, i) => {
                    return (
                      <MenuItem value={role.id} key={i}>
                        {role.name}
                      </MenuItem>
                    )
                  })}
              </Select>
            </Grid>
            {hasAccess() && selectedRole && selectedRole.id && editRole ? (
              <Grid item xs={12} sm={12} md={12} lg={6} className="role_permissions">
                <Grid
                  container
                  alignItems="flex-end"
                  justify="flex-end"
                  className="margin-top margin-top-des"
                >
                  <EditActionComponent
                    editMode={editMode}
                    onEdit={this.enableEdit}
                    onSave={this.onSave}
                    onCancel={() => this.onCancel(selectedRole)}
                  />
                  {!editMode ? (
                    <Fragment>
                      <Button className="primary-button margin" onClick={this.enableAllPermissions}>
                        Enable All
                      </Button>
                      <Button className="danger-button margin" onClick={this.disableAllPermissions}>
                        Disable All
                      </Button>
                    </Fragment>
                  ) : null}
                </Grid>
              </Grid>
            ) : null}
            <Grid item xs={12} sm={12} md={12} lg={12}>
              {(permissionsGroupOrderFiltered &&
                permissionsGroupOrderFiltered.length &&
                permissionsGroupOrderFiltered.map((groupOrder, i) => {
                  let validatedCatalog = true
                  if (
                    groupOrder === 'Master Catalog' &&
                    companyFeatures &&
                    !companyFeatures.enableMasterCatalog
                  ) {
                    validatedCatalog = false
                  }

                  let validateWorkerApp = true
                  if (
                    groupOrder === 'Manufacturing' &&
                    companyFeatures &&
                    companyFeatures.availableApps
                  ) {
                    if (
                      companyFeatures.availableApps.find((app) => app === 'Worker') === undefined
                    ) {
                      validateWorkerApp = false
                    }
                  }

                  let validateBlazeCapital = true
                  if (groupOrder === 'BLAZE Capital' && !process.env.BLAZE_CAPITAL) {
                    validateBlazeCapital = false
                  }

                  const fileteredPermissions =
                    permissionsToRender &&
                    permissionsToRender.length &&
                    permissionsToRender.filter((row) => {
                      return row.group === groupOrder
                    })

                  return (
                    ( validatedCatalog &&
                      validateWorkerApp &&
                      validateBlazeCapital &&
                      selectedRole &&
                      selectedRole.id &&
                      fileteredPermissions &&
                      fileteredPermissions.length && (
                        <Paper key={i} elevation={2} className="margin-top-medium">
                          <Grid item lg={12} style={{ padding: 30 }}>
                            <Typography
                              className="select-title-head"
                              variant="display1"
                              gutterBottom
                            >
                              {permissionsGroupOrderMap[groupOrder]}
                            </Typography>
                            <div className="table-scroll">
                              <Table>
                                <TableHead>
                                  <TableRow>
                                    <TableCell>Permission</TableCell>
                                    <TableCell>Description</TableCell>
                                    <TableCell className={editMode ? 'text-center' : ''}>
                                      Status
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {(selectedRole &&
                                    selectedRole.id &&
                                    fileteredPermissions &&
                                    fileteredPermissions.length &&
                                    fileteredPermissions.map((row, i) => {
                                      const status =
                                        selectedRole.permissions &&
                                        selectedRole.permissions.find((permission, index) => {
                                          return permission === row.key
                                        })
                                      return row.permission && row.group === groupOrder ? (
                                        <TableRow key={i}>
                                          <TableCell>{row.permission}</TableCell>
                                          <TableCell>{row.description}</TableCell>
                                          <TableCell className={editMode ? 'text-center' : ''}>
                                            <EditableSwitch
                                              valueToRender={status ? 'Enabled' : 'Disabled'}
                                              editMode={editMode}
                                              checked={Boolean(status)}
                                              onChange={() => 
                                                this.updatePermissionStatus(
                                                  selectedRole,
                                                  status,
                                                  row.key,
                                                  fileteredPermissions,
                                                  groupOrder,
                                                  row.permission
                                                )
                                              }
                                            />
                                          </TableCell>
                                        </TableRow>
                                      ) : null
                                    })) || (
                                    <TableRow>
                                      <TableCell>
                                        <h4 className="text-center">
                                          No Permissions for this role
                                        </h4>
                                      </TableCell>
                                    </TableRow>
                                  )}
                                </TableBody>
                              </Table>
                            </div>
                          </Grid>
                        </Paper>
                      )) ||
                    null
                  )
                })) ||
                null}
            </Grid>
            {!selectedRole || !selectedRole.id ? (
              <Grid container>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <Typography variant="title" gutterBottom className="margin-top-small set-font">
                    Please select a role.
                  </Typography>
                </Grid>
              </Grid>
            ) : null}
          </Grid>
        </Grid>
      </Grid>
    )
  }
}
export default withStyles(useStyles)(
  connect((state) => ({ dispatch: state.dispatch, companyReducer: state.companyReducer }))(
    RolePermissions,
  ),
)



// WEBPACK FOOTER //
// ./src/components/RolePermissions/index.js